module.exports = __webpack_public_path__ + "static/media/rafiki.e1bc5b59.png";